import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  SectionTitle,
  Showcase,
  Intro,
} from '../../../../components'

import data from './data.json'

export default props => {
  const timeout = 3000
  const asynctimeout = 8000

  const startFPL = () => {
    document.getElementById('fpl-overlay').classList.toggle('u-is-hidden')
    document.getElementById('fpl').classList.toggle('u-is-hidden')
    setTimeout(() => {
      document.getElementById('fpl-overlay').classList.toggle('u-is-hidden')
      document.getElementById('fpl').classList.toggle('u-is-hidden')
    }, timeout)
    setTimeout(timeout)
  }

  const startRegion = () => {
    document.getElementById('rbl-overlay').classList.toggle('u-is-hidden')
    document.getElementById('rbl').classList.toggle('u-is-hidden')
    setTimeout(() => {
      document.getElementById('rbl-overlay').classList.toggle('u-is-hidden')
      document.getElementById('rbl').classList.toggle('u-is-hidden')
    }, timeout)
    setTimeout(timeout)
  }

  const startAsync = () => {
    document.getElementById('nbl').classList.toggle('u-is-hidden')
    setTimeout(() => {
      document.getElementById('check').classList.add('c-loading__check')
      document
        .getElementById('nbl-spinner')
        .classList.add('c-loading__spinner--complete')
      document.getElementById('nbl-content').innerText = 'You did it!'
    }, timeout)
    setTimeout(() => {
      document.getElementById('nbl').classList.toggle('u-is-hidden')
    }, asynctimeout)
    document
      .getElementById('nbl-spinner')
      .classList.remove('c-loading__spinner--complete')
    document.getElementById('check').classList.remove('c-loading__check')
    document.getElementById('nbl-content').innerText = "You're doing it..."
  }

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Action indicators let users know when there is a background task
            underway. Depending on the type of indicator used, it may disappear
            or its state may change when the task is complete. These indicators
            assure a user that the system is still working as intended.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          title="Full-page blocking"
          text='A full-page blocking indicator is system-triggered and appears on page load. A gray overlay takes over the entire screen and a white container with the loading spinner and "Loading..." copy is centered on the layout. When the background task is complete, the indicator and overlay disappear and are replaced by the page content.'
          code={code.fullpage}
        >
          <button class="c-button" onClick={() => startFPL()}>
            Launch Full-page-Blocking Indicator
          </button>
          <p class="c-text-content-caption--normal l-margin-top--xsmall">
            The indicator will time out after three seconds.
          </p>

          <div class="c-loading__overlay u-is-hidden" id="fpl-overlay">
            <div class="c-loading u-is-hidden" id="fpl">
              <div class="c-loading__spinner" id="spinner"></div>
              <div class="c-loading__content" id="content">
                Loading...
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          id="Region"
          title="Region blocking"
          text="A region blocking indicator will appear over a specific content region. The overlay will only cover the area of the layout where the content is expected to appear and the indicator is centered on the overlay. When the background task is complete, the indicator is replaced by the content in that region."
          code={code.region}
        >
          <button class="c-button" onClick={() => startRegion()}>
            Launch Region-Blocking Indicator
          </button>
          <p class="c-text-content-caption--normal l-margin-top--xsmall">
            The indicator will time out after three seconds.
          </p>
          <div
            class="c-loading__overlay--contained u-is-hidden"
            id="rbl-overlay"
          >
            <div class="c-loading u-is-hidden" id="rbl">
              <div class="c-loading__spinner" id="spinner"></div>
              <div class="c-loading__content" id="content">
                Loading...
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          title="Non-blocking"
          text="Use the non-blocking indicator when a user may still interact with the expereince while the background task is taking place. Because they do not interfere with a user's process, non-blocking indicators should use both the in-progress and completed states detailed below to alert the user when the task is complete. When confirming saved changes in response to a form submission, use a success notification."
          code={code.nonblocking}
        >
          <div class="p-action-group">
            <div class="p-action-group__button-container">
              <button
                class="c-button p-action-group__button"
                onClick={() => startAsync()}
              >
                Launch Non-blocking Indicator
              </button>
            </div>
          </div>

          <div class="c-loading c-loading--non-blocking u-is-hidden" id="nbl">
            <div class="" id="check"></div>
            <div class="c-loading__spinner" id="nbl-spinner"></div>
            <div class="c-loading__content" id="nbl-content">
              Saving...
            </div>
          </div>
        </Showcase>
        <hr />

        <SectionTitle>States</SectionTitle>
        <p>
          The non-blocking indicator has an in-progress and a completed state.
        </p>
        <Showcase
          title="In-Progress"
          text="Shown when the system action is underway."
        >
          <div
            class="c-loading c-loading--non-blocking u-position--relative"
            id="nbl"
          >
            <div class="" id="check"></div>
            <div class="c-loading__spinner" id="nbl-spinner"></div>
            <div class="c-loading__content" id="nbl-content">
              You're doing it...
            </div>
          </div>
        </Showcase>

        <Showcase
          title="Complete"
          text="Shown once the system has completed the action. It will remain on-screen for six seconds"
        >
          <div
            class="c-loading c-loading--non-blocking u-position--relative"
            id="nbl"
          >
            <div class="c-loading__check" id="check"></div>
            <div
              class="c-loading__spinner c-loading__spinner--complete"
              id="nbl-spinner"
            ></div>
            <div class="c-loading__content" id="nbl-content">
              Saved
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>

        <p>
          The position of the blocking indicators will always be centered over
          the gray overlay, either over the entire page or a particular content
          region. The position of the non-blocking indicator will always appear
          centered and the top of the user's screen so that it does not
          interfere with other layout elements. Because they exist in the frame
          level of the{' '}
          <Link
            class="link"
            to={'/' + data.site + '/guidelines/elevation/develop'}
          >
            elevation
          </Link>{' '}
          structure, non-blocking action indicators use a medium{' '}
          <Link class="link" to={'/' + data.site + '/utilities/shadow/develop'}>
            shadow
          </Link>
          . The position will always be fixed, regardless of scroll position.
          When arranging components in the underlying layout, be aware that they
          will scroll behind the autosave component when it appears.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          The label should give theh user an indication of what is happening in
          the background using a present participle (-ing) verb form, i.e.
          Downloading, Submitting, Saving. For the completed state of the
          non-blocking indicator, use the same verb in the simple past tense,
          i.e. Downloaded, Submitted, Saved.
        </p>
      </Layout>
    </>
  )
}
export const code = {
  nonblocking: `<div class="c-loading c-loading--non-blocking">
  <div class=""></div>
  <div class="c-loading__spinner"></div>
  <div class="c-loading__content">
    In Progress...
  </div>
</div>`,
  region: `<div
class="c-loading__overlay--contained">
<div class="c-loading">
  <div class="c-loading__spinner"></div>
  <div class="c-loading__content">
    Loading...
  </div>
</div>
</div>`,
  fullpage: `<div class="c-loading__overlay">
<div class="c-loading">
  <div class="c-loading__spinner"></div>
  <div class="c-loading__content">
    Loading...
  </div>
</div>
</div>`,
}
